import { Link } from "react-router-dom";
import { ShieldCheck, Star } from "lucide-react";
import { formatMoney } from "../lib/api";

export default function PartCard({ part }) {
  return (
    <Link
      to={`/parts/${part.part_id}`}
      className="card-apa p-4 flex flex-col gap-3 group hover:border-[#009A44] transition-all duration-300 hover:-translate-y-1"
      data-testid={`part-card-${part.part_id}`}
    >
      <div className="aspect-square bg-zinc-100 overflow-hidden relative">
        <img
          src={part.image_url}
          alt={part.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {part.verified_by_agent && (
          <div
            className="absolute top-2 left-2 bg-[#FFD100]/95 text-[#121212] border border-[#121212] text-[10px] font-bold uppercase tracking-wider px-2 py-1 flex items-center gap-1"
            data-testid="agent-verified-badge"
          >
            <ShieldCheck size={11} /> Agent Verified
          </div>
        )}
        <div className="absolute top-2 right-2 bg-[#121212]/95 text-white text-[10px] font-semibold uppercase px-2 py-1">
          {part.condition}
        </div>
      </div>
      <div className="flex-1 space-y-2">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold">
          {part.category} · {part.brand}
        </div>
        <div className="font-semibold text-[14px] leading-snug line-clamp-2 min-h-[40px]">
          {part.name}
        </div>
        <div className="text-xs text-zinc-500 font-mono">
          PN: {part.part_number}
        </div>
        {part.rating > 0 && (
          <div className="flex items-center gap-1 text-xs text-zinc-600">
            <Star size={12} fill="#FFD100" stroke="#FFD100" />
            <span className="font-semibold">{part.rating}</span>
            <span>({part.reviews_count})</span>
          </div>
        )}
      </div>
      <div className="flex items-end justify-between pt-3 border-t border-[#E4E4E7]">
        <div>
          <div className="text-[10px] text-zinc-500 uppercase tracking-wider">Price</div>
          <div className="font-display text-xl font-extrabold" data-testid="part-price">
            {formatMoney(part.price, part.currency)}
          </div>
        </div>
        <div className="text-[10px] text-right">
          <div className="text-zinc-500 uppercase tracking-wider">Stock</div>
          <div className="font-semibold text-[#009A44]">{part.stock}+</div>
        </div>
      </div>
    </Link>
  );
}
